module.exports = __webpack_public_path__ + "img/male.9716dd6e.png";